/**
 * Período de evaluación / empleado del mes: siempre el mes anterior al actual.
 * Ej. en julio se evalúa y muestra el ranking de junio.
 */
export function getDefaultEvaluationPeriod(date = new Date()) {
  const monthIndex = date.getMonth(); // 0 = enero
  if (monthIndex === 0) {
    return { year: date.getFullYear() - 1, month: 12 };
  }
  return { year: date.getFullYear(), month: monthIndex };
}
